// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var User_Api = require("./User_Api.bs.js");
var User_Type = require("./User_Type.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Type_Common = require("../type/Type_Common.bs.js");
var Type_String = require("../type/Type_String.bs.js");
var Util_Result = require("../util/Util_Result.bs.js");
var AdsException = require("../AdsException.bs.js");
var User_Context = require("./User_Context.bs.js");
var User_Storage = require("./User_Storage.bs.js");
var User_Observable = require("./User_Observable.bs.js");
var Shim = require("use-sync-external-store/shim");

var notifyUserStatusChanged = User_Observable.UserStatus.notify;

var notifyStatusChanged = User_Observable.Status.notify;

var notifyMagazineChanged = User_Observable.Magazine.Magazine.Observable.notify;

var notifyAnonymousFeatureStatus = User_Observable.AnonymousFeatureStatus.notify;

function notifyAll(user) {
  Belt_Option.forEach(User_Type.getAllProgressionsAndFavoriteStatus(user), (function (__x) {
          Belt_Array.forEach(__x, (function (param) {
                  var dsId = param.dsId;
                  Curry._2(User_Observable.Favorite.FavoriteStatus.notify, dsId, param.favoriteStatus);
                  Curry._2(User_Observable.Progression.notify, dsId, param.progression);
                }));
        }));
  Belt_Array.forEach(User_Type.getMagazines(user), (function (dsId) {
          Curry._2(notifyMagazineChanged, dsId, true);
        }));
  Belt_Option.forEach(User_Type.getToken(user), (function (token) {
          Curry._1(User_Observable.Token.notify, token);
        }));
  Curry._1(notifyAnonymousFeatureStatus, User_Type.getAnonymousFeatureStatus(user));
  Curry._1(notifyUserStatusChanged, User_Type.getUserStatus(user));
  Curry._1(notifyStatusChanged, User_Context.getStatus(undefined));
}

function setStatus(newStatus) {
  User_Context.setStatus(newStatus);
  Curry._1(User_Observable.Status.notify, newStatus);
}

function persistUser(anonymousFeatureStatus, user) {
  var user$1 = anonymousFeatureStatus !== undefined ? User_Type.updateAnonymousFeatureStatus(user, anonymousFeatureStatus) : user;
  User_Context.setUser(user$1);
  notifyAll(user$1);
}

var useToken = User_Observable.Token.Hook.use;

var useUserStatus = User_Observable.UserStatus.Hook.use;

var useStatus = User_Observable.Status.Hook.use;

function useTokenStatus(param) {
  var match = React.useState(function () {
        return /* NotReady */0;
      });
  var setState = match[1];
  var token = Curry._1(useToken, undefined);
  var status = Curry._1(useStatus, undefined);
  React.useEffect((function () {
          var exit = 0;
          if (token !== undefined) {
            if (typeof token === "number") {
              if (status) {
                exit = 1;
              } else {
                Curry._1(setState, (function (param) {
                        return /* Disconnected */1;
                      }));
              }
            } else if (token.TAG === /* Anonymous */0) {
              if (status) {
                exit = 1;
              } else {
                Curry._1(setState, (function (param) {
                        return /* Anonymous */2;
                      }));
              }
            } else if (status) {
              exit = 1;
            } else {
              Curry._1(setState, (function (param) {
                      return /* Connected */3;
                    }));
            }
          } else {
            exit = 1;
          }
          if (exit === 1) {
            Curry._1(setState, (function (param) {
                    return /* NotReady */0;
                  }));
          }
          
        }), [
        token,
        status
      ]);
  return match[0];
}

function useConnectedToken(param) {
  var token = Curry._1(useToken, undefined);
  if (token !== undefined && !(typeof token === "number" || token.TAG === /* Anonymous */0)) {
    return Curry._1(Type_String.User.Token.connectedToString, token._0);
  }
  
}

var useAnonymousFeatureStatus = User_Observable.AnonymousFeatureStatus.Hook.use;

var Hook = {
  useToken: useToken,
  useUserStatus: useUserStatus,
  useStatus: useStatus,
  useTokenStatus: useTokenStatus,
  useConnectedToken: useConnectedToken,
  useAnonymousFeatureStatus: useAnonymousFeatureStatus
};

var reconcileUser = User_Type.merge;

async function getDatas(envOpt, signal, storedUser, token) {
  var env = envOpt !== undefined ? envOpt : "prod";
  var datas = await User_Api.Me.Data.get(env, signal, token);
  if (datas.TAG !== /* Ok */0) {
    return Belt_Option.getWithDefault(storedUser, User_Type.make(undefined, undefined, undefined, token));
  }
  var match = datas._0;
  var favorites = Belt_Option.getWithDefault(match.favorites, []);
  var lastvieweds = Belt_Option.mapWithDefault(match.lastvieweds, [], (function (lastvieweds) {
          return Belt_Array.map(lastvieweds, (function (param) {
                        return {
                                id: param.programId,
                                progression: Type_Common.Progression.makeFromPct(param.timecode, param.progress)
                              };
                      }));
        }));
  var userFromMona = User_Type.make(Belt_Option.map(match.subscriptions, (function (__x) {
              return Belt_Array.map(__x, Type_String.Teaser.DsId.make);
            })), favorites, lastvieweds, token);
  return Belt_Option.mapWithDefault(storedUser, userFromMona, (function (__x) {
                return User_Type.merge(__x, userFromMona);
              }));
}

async function disconnect(env, token, callback) {
  if (token === undefined) {
    return ;
  }
  if (typeof token === "number") {
    return ;
  }
  if (token.TAG === /* Anonymous */0) {
    return ;
  }
  await User_Api.Auth.logout(env, token);
  persistUser(undefined, User_Type.disconnected);
  return Curry._1(callback, undefined);
}

function loginUser(token, env) {
  var controller = new AbortController();
  Belt_Option.forEach(env, User_Context.setEnv);
  var storedUser = Curry._1(User_Storage.get, undefined);
  var partial_arg = controller.signal;
  var getDatas$1 = function (param, param$1) {
    return getDatas(env, partial_arg, param, param$1);
  };
  var storedUserOpt = Util_Result.toOption(storedUser);
  User_Storage.setToken(token);
  Curry._2(getDatas$1, storedUserOpt, token).then(function (user) {
        persistUser(undefined, user);
        setStatus(/* Initialized */0);
      });
}

async function loginAnonymousUser(env, getDatas, anonymousFeatureStatus, param) {
  var token = await User_Api.Token.get(env, undefined);
  if (token.TAG === /* Ok */0) {
    var token$1 = token._0;
    Curry._1(User_Observable.Token.notify, token$1);
    var user = await Curry._2(getDatas, undefined, token$1);
    setStatus(/* Initialized */0);
    return persistUser(undefined, user);
  }
  setStatus(/* Initialized */0);
  return persistUser(anonymousFeatureStatus, User_Type.disconnected);
}

function getSnapshot(param) {
  
}

function subscribe(env, param) {
  var controller = new AbortController();
  Belt_Option.forEach(env, User_Context.setEnv);
  var status = Curry._2(User_Observable.Status.Base.getInitialValue, undefined, undefined);
  var init = async function (param) {
    if (status === undefined) {
      return ;
    }
    if (!status) {
      return ;
    }
    var storedUser = Curry._1(User_Storage.get, undefined);
    var partial_arg = controller.signal;
    var getDatas$1 = function (param, param$1) {
      return getDatas(env, partial_arg, param, param$1);
    };
    var storedUserOpt = Util_Result.toOption(storedUser);
    var anonymousFeatureStatus;
    anonymousFeatureStatus = storedUser.TAG === /* Ok */0 ? User_Type.getAnonymousFeatureStatus(storedUser._0) : /* Enabled */0;
    var loginAnonymousUser$1 = function (param) {
      return loginAnonymousUser(env, getDatas$1, anonymousFeatureStatus, param);
    };
    Curry._1(User_Observable.AnonymousFeatureStatus.notify, anonymousFeatureStatus);
    if (storedUser.TAG === /* Ok */0) {
      var token = await User_Api.Auth.login(env, undefined);
      var exit = 0;
      var token$1;
      if (token.TAG === /* Ok */0) {
        var token$2 = token._0;
        if (typeof token$2 === "number" || token$2.TAG === /* Anonymous */0 && anonymousFeatureStatus) {
          exit = 1;
        } else {
          token$1 = token$2;
          exit = 2;
        }
      } else {
        exit = 1;
      }
      switch (exit) {
        case 1 :
            if (anonymousFeatureStatus) {
              setStatus(/* Initialized */0);
              return persistUser(anonymousFeatureStatus, User_Type.disconnected);
            } else {
              loginAnonymousUser$1(undefined);
              return ;
            }
        case 2 :
            Curry._1(User_Observable.Token.notify, token$1);
            User_Storage.setToken(token$1);
            var user = await Curry._2(getDatas$1, storedUserOpt, token$1);
            persistUser(undefined, user);
            return setStatus(/* Initialized */0);
        
      }
    } else {
      var match = storedUser._0;
      if (match === 0) {
        return ;
      }
      switch (match) {
        case /* NotFound */1 :
            loginAnonymousUser$1(undefined);
            return ;
        case /* FromDummyStorage */2 :
            setStatus(/* Initialized */0);
            persistUser(undefined, User_Type.disconnected);
            console.log(AdsException.exnToString("FirefoxStorage"));
            return ;
        case /* StorageError */3 :
            return ;
        
      }
    }
  };
  init(undefined);
  return function () {
    controller.abort();
  };
}

function User_Provider(Props) {
  var children = Props.children;
  var env = Props.env;
  Shim.useSyncExternalStore((function (param) {
          return subscribe(env, param);
        }), getSnapshot, getSnapshot);
  return children;
}

var make = User_Provider;

exports.notifyUserStatusChanged = notifyUserStatusChanged;
exports.notifyStatusChanged = notifyStatusChanged;
exports.notifyMagazineChanged = notifyMagazineChanged;
exports.notifyAnonymousFeatureStatus = notifyAnonymousFeatureStatus;
exports.notifyAll = notifyAll;
exports.setStatus = setStatus;
exports.persistUser = persistUser;
exports.Hook = Hook;
exports.reconcileUser = reconcileUser;
exports.getDatas = getDatas;
exports.disconnect = disconnect;
exports.loginUser = loginUser;
exports.loginAnonymousUser = loginAnonymousUser;
exports.getSnapshot = getSnapshot;
exports.subscribe = subscribe;
exports.make = make;
/* react Not a pure module */
